<div
  class="duration-picker-field"
  [ngClass]="{
    'has-value': selectedOption?.key !== placeholder,
    condensed: condensed
  }"
>
  <div
    class="duration-picker-label-wrapper field-label"
    [ngClass]="{
      'sr-text': hideLabel,
      disabled: formControl?.disabled
    }"
  >
    <label
      class="duration-picker-label"
      type="select"
      [attr.for]="fieldId"
      (click)="dropdown.open()"
    >
      {{ label }}
    </label>

    <app-icon
      *ngIf="icon"
      class="icon"
      [icon]="icon"
      (click)="onClickIcon.emit()"
    >
    </app-icon>
  </div>

  <app-dropdown
    #dropdown
    class="duration-picker-dropdown"
    [dropdownGroupedItems]="dropdownValues"
    [e2eId]="e2eId"
    [disabled]="isDisabled"
    [dropdownId]="fieldId"
    [horizontalAlignment]="horizontalAlignment"
    [verticalAlignment]="verticalAlignment"
    [dynamicVAlignment]="dynamicVAlignment"
    [triggerLabel]="selectedOption?.key || placeholder"
    [trackingObject]="trackingObject"
    [trackingAction]="trackingTapped"
    [trackingAdditionalProperties]="trackingAdditionalProperties"
  >
    <ng-template
      let-closeCallback="closeCallback"
      let-selectOption="dropdownItem"
    >
      <button
        type="button"
        class="select-option"
        [disabled]="isDisabled"
        tabindex="0"
        [ngClass]="{ selected: selectOption.key === selectedOption?.key }"
        (click)="onSelect(selectOption); closeCallback()"
      >
        <div class="select-option-contents">
          {{ selectOption.key }}

          <app-checkmark
            class="checkmark"
            [hidden]="selectOption.key !== selectedOption?.key"
          >
          </app-checkmark>

          <app-icon
            *ngIf="selectOption.icon"
            class="select-option-icon"
            [icon]="selectOption.icon"
          >
          </app-icon>
        </div>
      </button>
    </ng-template>
  </app-dropdown>
</div>

<app-error-message [fieldControl]="fieldControl" [errorMessage]="errorMessage">
</app-error-message>

<p *ngIf="description" class="description">
  {{ description }}
</p>
